import { FORM_SETTINGS } from '../elements/formSettings'

export const ROI_CALCULATOR_V2 = `
...on roiCalculatorV2_Entry {
  id
  typeHandle
  headingAdvanced {
    html
  }

  ${FORM_SETTINGS}
  
}`